import './Hero.css';
import fotoEmilse from '../assets/foto-perfil.jpg';

const Hero = () => {
  return (
    <section className="hero" id="sobre-mi">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Disponible para proyectos
          </div>
          <h1 className="hero-title">
            Hola, soy <span className="hero-name-gradient">Emilse Diaz</span>
          </h1>
          <p className="hero-role">Desarrolladora web full stack</p>
          <p className="hero-description">
            Construyo aplicaciones web con React, Next.js y Node. Me apasiona aprender
            nuevas tecnologías y crear interfaces que funcionen bien y se vean mejor.
          </p>
          <div className="hero-buttons">
            <a href="#proyectos" className="btn btn-primary">
              Ver proyectos →
            </a>
            <a href="/cv-emilse-diaz.pdf" download className="btn btn-secondary">
              Descargar CV
            </a>
          </div>
        </div>
        <div className="hero-photo">
          <img src={fotoEmilse} alt="Emilse Diaz" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
